export const aToolbar = {
    tEvents: {},
    on: function (eventName, callback) {
        console.log("toolbar on:", this.tEvents, eventName, callback);

        if (this.tEvents[eventName] === undefined) {
            this.tEvents[eventName] = [];
        }
        this.tEvents[eventName].push(callback);
    },
    off: function (eventName, callback) {
        console.log("toolbar off:", this.tEvents, eventName, callback);
        if (this.tEvents[eventName]) {
            if (callback) {
                var index = this.tEvents[eventName].indexOf(callback);
                console.log("toolbar off:", eventName, callback, index);
                if (index !== -1) {
                    this.tEvents[eventName].splice(index, 1);
                }
            } else {
                this.tEvents[eventName] = [];
            }
        }
    },
    trigger: function (eventName, options) {
        if (this.tEvents[eventName]) {
            this.tEvents[eventName].forEach(callback => {
                callback && callback.apply(window, options)
            });
        }
    }
};